declare global {
  interface Window {
    config?: any;
    jQuery?: any;
    slideTo: Function;
  }
}

export default window.config;
